export enum Method {
  Yeast2ConzViab = 30,
  Yeast2Conz = 31,
  Yeast2Brett = 32,
  BioEthConzViab = 33,
  BioEthConz = 34,
  BioEthrett = 35,
  WineConzViab = 40,
  WineConz = 41,
  WineBrett = 42,
  WineManualCnt = 43,
}

export const WineMethods = [
  Method.WineBrett,
  Method.WineConz,
  Method.WineConzViab,
  Method.WineManualCnt,
];

export const YeastMethods = [
  Method.Yeast2Brett,
  Method.Yeast2Conz,
  Method.Yeast2ConzViab,
];

export const BioEthMethods = [
  Method.BioEthrett,
  Method.BioEthConz,
  Method.BioEthConzViab,
];
